
import React from 'react';
import CallToActionSection from './CallToActionSection';
import ProcessHeader from './process/ProcessHeader';
import ProcessStep from './process/ProcessStep';
import { processSteps } from './process/processSteps';
import { useProcessAnimation } from './process/useProcessAnimation';

interface ProcessSectionProps {
  onValuationClick: () => void;
}

const ProcessSection = ({ onValuationClick }: ProcessSectionProps) => {
  const { getStepProgress, getActiveStep } = useProcessAnimation('process-section');

  return (
    <section id="process-section" className="py-12 md:py-16 lg:py-20 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-4xl">
        <ProcessHeader />

        <div className="ml-6 md:ml-12">
          {processSteps.map((step, index) => {
            const stepProgress = getStepProgress(index);
            const isActive = getActiveStep(index);
            
            return (
              <ProcessStep
                key={index}
                step={{
                  ...step,
                  icon: <step.icon className="w-5 h-5 md:w-6 md:h-6" />
                }}
                index={index}
                stepProgress={stepProgress}
                isActive={isActive}
                isLastStep={index === processSteps.length - 1}
              />
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="mt-2">
          <CallToActionSection onValuationClick={onValuationClick} />
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
